<script setup name="TvbHomeSmallBanner">
import request from '@/utils/request'
import { reactive, ref, inject, onServerPrefetch } from 'vue'

import TvbHomeSmallBannerTemplateTwo from './components/TemplateTwo/index.vue'
import TvbHomeSmallBannerTemplateThree from './components/TemplateThree/index.vue'
import TvbHomeSmallBannerTemplateFour from './components/TemplateFour/index.vue'
const templateRef = ref()
const size = inject('size')
const props = defineProps({
  info: {
    type: Object,
    default: null
  }
})
const smallBanner = reactive({
  big: null,
  list: [],
  template: 0,
  moreUrl: ''
})

const smallBannerTemplates = {
  2: TvbHomeSmallBannerTemplateTwo,
  3: TvbHomeSmallBannerTemplateThree,
  4: TvbHomeSmallBannerTemplateFour
}
const smallBannerShowNavNum = {
  2: 6,
  3: 5,
  4: 4
}

const fetchData = async () => {
  if (props.info.api) {
    const { data } = await request({
      url: props.info.api,
      method: 'get'
    })
    let { list, template } = data
    if (6 < list.length && template === 2) {
      let listLen = list.length
      let listMod = listLen % 6
      list = listLen > 6 && listMod > 0 ? list.concat(list.slice(0, 6 - (list.length % 6))) : list
    } else if (template === 3) {
      smallBanner.big = list[0]
      list = list.slice(1)
      let listLen = list.length
      let listMod = listLen % 4
      list = listLen > 4 && listMod > 0 ? list.concat(list.slice(0, 4 - listMod)) : list
    }
    smallBanner.template = template
    smallBanner.list = list
  }
}
fetchData()
onServerPrefetch(fetchData)
</script>

<template>
  <section class="tvb-home-small-banner" v-if="smallBanner.list.length" :class="[size]">
    <header class="tvb-home-small-banner-header">
      <h2 class="tvb-home-small-banner-title">
        <component
          :is="smallBanner?.moreUrl ? 'tvb-router-link' : 'span'"
          :to="smallBanner?.moreUrl"
        >
          {{ info.title }}
        </component>
      </h2>
      <div
        class="tvb-home-small-banner-swiper-navigation"
        v-if="smallBannerShowNavNum[smallBanner.template] < smallBanner.list.length"
      >
        <div class="tvb-home-small-banner-swiper-navigation-prev" @click="templateRef?.slidePrev()">
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_black" />
        </div>
        <div class="tvb-home-small-banner-swiper-navigation-next" @click="templateRef?.slideNext()">
          <TvbSvgIcon class="arrow-icon" name="icon_list_arrow_black" />
        </div>
      </div>
    </header>
    <component
      :list="smallBanner.list"
      :is="smallBannerTemplates[smallBanner.template]"
      :big="smallBanner.big"
      :info="props.info"
      ref="templateRef"
    />
  </section>
</template>

<style lang="scss" scoped>
.tvb-home-small-banner {
  min-width: 320px;
  .tvb-home-small-banner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tvb-home-small-banner-title {
      font-size: 22px;
      font-weight: 500;
      color: #231f20;
      line-height: 36px;
      letter-spacing: 0.5px;
      > a {
        text-decoration: none;
        color: inherit;
        @include text-hover-before();
        &:hover {
          @include text-hover-active();
        }
      }
    }

    .tvb-home-small-banner-swiper-navigation {
      display: flex;
      align-items: center;
      justify-content: center;

      .tvb-home-small-banner-swiper-navigation-prev {
        svg {
          transform: rotate(180deg);
          &:nth-child(2) {
            transform: rotate(0deg) !important;
          }
        }
      }

      .tvb-home-small-banner-swiper-navigation-prev,
      .tvb-home-small-banner-swiper-navigation-next {
        transition: all 0.15s linear;
        width: 40px;
        height: 36px;
        border-radius: 12px;
        background: #f5f6f7;
        margin-left: 12px;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        svg {
          width: 16px;
          height: 16px;
        }

        &:hover {
          background: #eceff3;
        }

        &:active {
          opacity: 0.75;
        }
      }

      .tvb-home-small-banner-swiper-navigation-next {
        margin-left: 12px;
      }
    }
  }
  &.s,
  &.xs {
    .tvb-home-small-banner-header {
      align-items: center;
      padding: 0 12px;
      .tvb-home-small-banner-title {
        font-size: 17px;
        font-weight: 500;
        color: #231f20;
        line-height: 24px;
      }

      .tvb-home-small-banner-swiper-navigation {
        display: none;
      }
    }
  }
  &.s {
    .tvb-home-small-banner-header {
      padding: 0 16px;
    }
  }

  &.l,
  &.m {
    .tvb-home-small-banner-header {
      .tvb-home-small-banner-title {
        font-size: 20px;
      }
    }
  }
}
</style>
